//================================================================
//  Component: RequestPane
//================================================================

//  Purpose: This side pane allows a user to view a digital business improvement request

//  Properties:
//    - paneOpen = { useState, holds a boolean value that opens and closes the sidePane}
//    - setPaneOpen = { useState, updates the boolean value that opens and closes the sidePane}
//    - selectedRequest = { useState, stores the currently selected request}
//    - setSelectedRequest = { useState, used to set the selected request }

//  Example:
//  
//    <RequestPane
//      paneOpen={openPane}
//      setPaneOpen={setOpenPane}
//      selectedRequest={selectedRequest}
//      setSelectedRequest={setSelectedRequest}
//    ></RequestPane>

//================================================================

// Libraries
import React from 'react';

// Contexts

// Functions

// Components
import NewInitiative from '../../Pages/Task/Components/TriageTab/DigitalRequestForms/NewInitiative';
import AdditionalLicense from '../../Pages/Task/Components/TriageTab/DigitalRequestForms/AdditionalLicense';
import ContractRenewal from '../../Pages/Task/Components/TriageTab/DigitalRequestForms/ContractRenewal';
import Decommission from '../../Pages/Task/Components/TriageTab/DigitalRequestForms/Decommission';
import Enhancement from '../../Pages/Task/Components/TriageTab/DigitalRequestForms/Enhancement';

// Images

export default function RequestPane({
    paneOpen,
    setPaneOpen,
    selectedRequest,
    setSelectedRequest
}) {

    // --------------------------------------------------
    //  HTML
    // --------------------------------------------------

    // ==================================================
    //  Hide Side Pane
    // ==================================================

    if (!paneOpen) return null;

    // ==================================================
    //  Show Side Pane  
    // ==================================================

    return (
        <div className='Pane-Background'>
            <dialog className='Pane-Container' style={{ width: '70vw' }}>
                <div className='grid grid-rows-[70px_1fr_70px] items-center justify-between w-full overflow-hidden' >

                    {/* ===================================== */}
                    {/*  Header                               */}
                    {/* ===================================== */}

                    <div className='flex flex-col gap-2 p-4'>
                        <h4 className='text-[22px] p-0 pb-0 m-0'> {selectedRequest?.requesttype} Request | {selectedRequest?.parentrequestid.toUpperCase()}</h4>
                    </div>

                    {/* ===================================== */}
                    {/*  Form                                 */}
                    {/* ===================================== */}

                    <div className='w-[60vw] h-full flex flex-col overflow-y-auto p-4 pt-2 border-solid border shadow-inner'>

                        <div>
                            {(() => {
                                switch (selectedRequest?.requesttype) {
                                    case 'New Initiative or Technology': return <NewInitiative task={selectedRequest}></NewInitiative>;
                                    case 'Contract Renewal': return <ContractRenewal task={selectedRequest}></ContractRenewal>;
                                    case 'Enhancement': return <Enhancement task={selectedRequest}></Enhancement>;
                                    case 'Additional Licenses or Overages': return <AdditionalLicense task={selectedRequest}></AdditionalLicense>;
                                    case 'Decommission': return <Decommission task={selectedRequest}></Decommission>;
                                    default: return 'Form not found';
                                }
                            })()}

                            <div  className='FormComponent-Row '>
                                <label className='font-medium'> Created By </label>
                                <input
                                    className='Input-Field-Text'
                                    style={{ width: '300px' }}
                                    type='text'
                                    value={selectedRequest?.createdby?.email}
                                    disabled
                                ></input>
                            </div>
                        </div>

                    </div>


                    {/* ===================================== */}
                    {/*  Close Button                         */}
                    {/* ===================================== */}

                    <div className='px-4 py-3'>
                        <button className='Primary-Button' onClick={() => {

                            // Reset Selected Request
                            setSelectedRequest();

                            // Close Side Pane
                            setPaneOpen(false);

                        }}>
                            Close
                        </button>
                    </div>

                </div>
            </dialog>
        </div>
    );
}
